import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { Spinner as ArkSpinner } from '@remarkable/ark-web';

export const Spinner = ({ inline }: { inline?: boolean }) => {
  if (inline) {
    return (
      <span data-cy="spinner" className="mx-4 inline-block w-fit">
        <ArkSpinner size="small" />
        <VisuallyHidden>Loading</VisuallyHidden>
      </span>
    );
  }

  return (
    <span data-cy="spinner" className="m-auto flex w-fit">
      <ArkSpinner size="large" />
      <VisuallyHidden>Loading</VisuallyHidden>
    </span>
  );
};

// Viewport-fixed so the spinner stays put while layouts mount around it.
export const RouteLoadingSpinner = () => (
  <div className="pointer-events-none fixed inset-0 flex items-center justify-center">
    <Spinner />
  </div>
);
